export default __webpack_public_path__ + "static/shield-ffd02d9f37ebeeb5f74b338ea9ec5870.svg";